/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunSetStateRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunSetStateRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunSetStateRequest>): WellArchitectedFrameworkAssessmentRunSetStateRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunSetStateRequest(), model);
        WellArchitectedFrameworkAssessmentRunSetStateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunSetStateRequest>): WellArchitectedFrameworkAssessmentRunSetStateRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunSetStateRequest.newInstance(<WellArchitectedFrameworkAssessmentRunSetStateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunSetStateRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunSetStateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunSetStateRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunSetStateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of the assessment run
     */
    status: models.WellArchitectedFrameworkAssessmentRunStatus;

}
